import { MillicastSource, Source, SourceDescription, TheoLiveSource, TypedSource } from 'theoplayer';

export interface QueryParams {
  license: string | undefined;
  sourceType: string | undefined;
  source: string | undefined;
  token: string | undefined;
  autoplay: boolean;
  muted: boolean;
  poster: string | undefined;
  color: string;
  maxDelay: number;
  minDelay: number;
  maxHeight?: string | null;
  maxWidth?: string | null;
}

export function convertToSourceDescription(params: QueryParams): SourceDescription | undefined {
  if (params.sourceType === undefined) {
    console.warn('Invalid source type.');
    return;
  }
  if (params.source === undefined) {
    console.warn('Invalid source.');
    return;
  }
  const sourceType = params.sourceType.toLowerCase();
  let sourceObject: Source;

  if (sourceType === 'live') {
    sourceObject = convertToHLSSource(params);
  } else if (sourceType === 'lowdelay') {
    sourceObject = convertToTHEOliveSource(params);
  } else if (sourceType === 'realtime') {
    sourceObject = convertToMillicastSource(params);
  } else if (sourceType === 'vod') {
    sourceObject = convertToVodSource(params);
  } else {
    throw new Error(`Unknown source type: ${sourceType}`);
  }
  return { sources: [sourceObject] };
}

export function convertToTHEOliveSource(params: QueryParams): TheoLiveSource {
  if (params.source === undefined) {
    throw new Error('Invalid THEOlive Source (undefined).');
  }
  return {
    type: 'theolive',
    src: params.source,
  };
}

export function convertToHLSSource(params: QueryParams): TypedSource {
  if (params.source === undefined) {
    throw new Error('Invalid HLS Source (undefined).');
  }
  return {
    type: 'application/x-mpegurl',
    src: params.source,
  };
}

export function convertToMillicastSource(params: QueryParams): MillicastSource {
  if (params.source === undefined) {
    // TODO: don't let an undefined source reach here, and improve types
    throw new Error('Invalid source.');
  }

  const splitSource = params.source.split('/');
  const streamAccountId = splitSource[0];
  const streamName = splitSource[1];

  const source: MillicastSource = {
    type: 'millicast',
    streamAccountId: streamAccountId,
    src: streamName,
    connectOptions: {},
  };

  if (params.maxDelay && params.minDelay) {
    source.connectOptions!.forcePlayoutDelay = {
      min: params.minDelay,
      max: params.maxDelay,
    };
  }

  if (Number(params.maxHeight)) {
    source.connectOptions!.layer = {
      maxHeight: params.maxHeight ? Number(params.maxHeight) : null,
    };
  }

  if (Number(params.maxWidth)) {
    source.connectOptions!.layer = {
      maxWidth: params.maxWidth ? Number(params.maxWidth) : null,
    };
  }

  if (params.token !== '') {
    source.subscriberToken = params.token;
  }
  return source;
}

export function convertToVodSource(params: QueryParams): Source {
  if (params.source === undefined) {
    // TODO: don't let an undefined source reach here, and improve types
    throw new Error('Invalid source.');
  }

  if (params.source.toLowerCase().includes(".mp4")) {

    // mp4 VOD source
    return {
      type: 'video/mp4',
      src: params.source,
    };

  } else if (params.source.toLowerCase().includes(".m3u8")) {
    
    // hls VOD source
    return {
      type: 'application/x-mpegurl',
      src: params.source,
    };

  } else if (params.source.toLowerCase().includes(".mpd")) {
    
    // dash VOD source
    return {
      type: 'application/dash+xml',
      src: params.source,
    };

  } else {
    throw new Error('Unrecognized VOD source.');
  }


}

export const needsNetworkInterceptor = (params: QueryParams) => {
  if (params.sourceType === undefined || params.token === undefined) {
    return false;
  }

  const typeOfSource = params.sourceType.toLowerCase();

  return typeOfSource === 'lowdelay' || typeOfSource === 'live';
};
